// Service for bulk tagging patients
// Endpoint: workspaces/<int:workspace_id>/tags/bulk/

import { useMutation } from "react-query";
import servicesUtils from "../../../utils/servicesUtils";
var useBulkTaggingService = function useBulkTaggingService(workspaceId) {
  return useMutation(function (data) {
    return servicesUtils.postService("/workspaces/".concat(workspaceId, "/tags/bulk/"), data);
  });
};
export default useBulkTaggingService;